// Copyright 2012 Jim Radford <radford@greenfelt.net>, David Caldwell <david@greenfelt.net>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var lib = require('./lib'), filter=lib.filter;

solitaire.calculation = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.stock = new this.calculation_stock("stock", this)
        this.foundation = []
        for (var f=1; f<=4; f++)
            this.foundation.push(new this.calculation_foundation("foundation"+f, this))
        this.tableau = []
        for (var t=1; t<=4; t++)
            this.tableau.push(new this.calculation_tableau("tableau"+t, this))
    }
    calculation_stock = class extends pile {
        accept(card) { return false }
        splice = super.splice_and_turn_over;
        maxstack = 52-4;
        xoffset = .5/90;
        yoffset = .5/131;
    }

    calculation_foundation = class extends pile {
        accept(card) { return this.pile.length < 13 && card.rank - ace == (this.top().rank - ace + this.pile[0].rank) % 13 ? 52+1 : 0 }
        can_drag(index) { return false }
        xoffset = 0;
        yoffset = 0;
    }

    calculation_tableau = class extends pile {
        maxstack = (52-4)/4;
        accept(card, from_pile) { return filter(function(p) { return p == from_pile }, this.game.tableau).length == 0 ? 52 - this.pile.length : 0 }
        can_drag(index) { return index == this.top_index() }
    }

    deal(deck) {
            for (var i=0; i<deck.length; i++) {
                var f = this.foundation[deck[i].rank-ace]
                if (f && f.pile.length == 0) {
                    f.push(deck.splice(i--,1)[0])
                    f.top().face = up
                }
            }
            this.stock.pile = deck
            this.stock.top().face = up
    }

    is_complete() { return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                           this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON }
    score() { return this.count_cards_in(this.foundation) - 4 }

    layout = grid(["stock",   {x: +.5}, "foundation1", "foundation2", "foundation3", "foundation4"],
                  [undefined, {x: +.5}, "tableau1",    "tableau2",    "tableau3",    "tableau4"  ]);
}

module.exports = solitaire.calculation;
// Copyright 2012 Jim Radford <radford@greenfelt.net>, David Caldwell <david@greenfelt.net>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, up=piles.up, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;
var lib = require('./lib'), filter=lib.filter;

solitaire.calculation = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.stock = new this.calculation_stock("stock", this)
        this.foundation = []
        for (var f=1; f<=4; f++)
            this.foundation.push(new this.calculation_foundation("foundation"+f, this))
        this.tableau = []
        for (var t=1; t<=4; t++)
            this.tableau.push(new this.calculation_tableau("tableau"+t, this))
    }
    calculation_stock = class extends pile {
        accept(card) { return false }
        splice = super.splice_and_turn_over;
        maxstack = 52-4;
        xoffset = .5/90;
        yoffset = .5/131;
    }

    calculation_foundation = class extends pile {
        accept(card) { return this.pile.length < 13 && card.rank - ace == (this.top().rank - ace + this.pile[0].rank) % 13 ? 52+1 : 0 }
        can_drag(index) { return false }
        xoffset = 0;
        yoffset = 0;
    }

    calculation_tableau = class extends pile {
        maxstack = (52-4)/4;
        accept(card, from_pile) { return filter(function(p) { return p == from_pile }, this.game.tableau).length == 0 ? 52 - this.pile.length : 0 }
        can_drag(index) { return index == this.top_index() }
    }

    deal(deck) {
            for (var i=0; i<deck.length; i++) {
                var f = this.foundation[deck[i].rank-ace]
                if (f && f.pile.length == 0) {
                    f.push(deck.splice(i--,1)[0])
                    f.top().face = up
                }
            }
            this.stock.pile = deck
            this.stock.top().face = up
    }

    is_complete() { return this.foundation[0].pile.length == 13 && this.foundation[1].pile.length == 13 &&
                           this.foundation[2].pile.length == 13 && this.foundation[3].pile.length == 13 && WON }
    score() { return this.count_cards_in(this.foundation) - 4 }

    layout = grid(["stock",   {x: +.5}, "foundation1", "foundation2", "foundation3", "foundation4"],
                  [undefined, {x: +.5}, "tableau1",    "tableau2",    "tableau3",    "tableau4"  ]);
}

module.exports = solitaire.calculation;
